var map = {
	"./Corner.png": "b3b4",
	"./Goals.png": "5477",
	"./NBA_DoubleShot.png": "6b0a",
	"./NBA_Foul.png": "4642",
	"./NBA_FreeThrow.png": "250b",
	"./NBA_FreeThrow1.png": "a94b",
	"./NBA_FreeThrow2.png": "cec2",
	"./NBA_FreeThrow3.png": "3838",
	"./NBA_Pass.png": "2642",
	"./NBA_SingleShot.png": "b54a",
	"./NBA_SingleShotMiss.png": "e212",
	"./NBA_TripleShot.png": "f9a4",
	"./Offside.png": "9172",
	"./RedCard.png": "cff8",
	"./YellowCard.png": "e260e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b055";